import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AlertService } from 'src/app/services/alert.service';
import { DptmasterService } from 'src/app/services/dptmaster.service';
@Component({
  selector: 'app-machinary-category',
  templateUrl: './machinary-category.component.html',
  styleUrls: ['./machinary-category.component.scss']
})


export class MachinaryCategoryComponent implements OnInit {

  data: any[] = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    'Name',
    // 'MachinaryCategoryType',
    'MachinaryClassification',
    'action'
  ];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) matSort: MatSort;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  loading: boolean = false;
  isShow: boolean;
  actionId: any;
  resultdata: any;

  constructor(
    private dptmasterservice: DptmasterService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.get()
  }

  get() {
    this.loading = true
    this.dptmasterservice.getMachinaryCategoryList().subscribe((res) => {
      this.data = res
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.matSort;
      this.loading = false
    })
  }

  onRefresh() {
    this.loading = true;
    this.searchInput.nativeElement.value = '';
    this.get();
  }

  add() {
    this.isShow = true;
    this.actionId = '0';
    this.resultdata = '';
  }
  editTarget(resultdata: any) {
    this.isShow = true;
    this.actionId = '1';
    this.resultdata = resultdata;
  }

  viewTarget(resultdata: any) {
    this.isShow = true;
    this.actionId = '2';
    this.resultdata = resultdata;
  }

  handelBack(event) {
    const val = event.value;
    this.isShow = val;
    this.get();
  }


  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLocaleLowerCase();
    if(this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
